import {
  CategoryGrid,
  LazyMarketingJackpotsProgressiveMoreInfoModal,
  LazyUserInterfaceSearch,
  LazyUserInterfaceShareModal,
} from '#components';
import type { IModalConfig, TModalConfig } from '~/interfaces/content/modals';
import type { ICategoriesAndGames } from '~/interfaces/stores/games.store.interface';

interface IGameModalConfig extends IModalConfig {
  games?: ICategoriesAndGames[];
  inModal?: boolean;
}

export const getGameModals = (): TModalConfig => {
  const game = useGameStore();
  return {
    progressiveJackpotsMoreInfo: {
      modalProps: { title: 'jackpots.progressive.more-info.title' },
      component: () => LazyMarketingJackpotsProgressiveMoreInfoModal,
    },
    search: {
      modalProps: { title: 'search-games' },
      component: () => LazyUserInterfaceSearch,
    },
    gameShare: {
      modalProps: { title: 'share', size: 'sm' },
      component: () => LazyUserInterfaceShareModal,
    },
    category: {
      modalProps: {
        title: `vertical.category.${game.returnCurrentCategory}`,
        class: 'flex flex-row flex-wrap items-center p-2',
      },
      contentProps: {
        games: game.returnCategory({ category: game?.returnCurrentCategory }),
        inModal: true,
      },
      component: () => CategoryGrid,
    } as unknown as IGameModalConfig,
  } as const satisfies TModalConfig;
};
